var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSberpay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7042 12.9711V15.0091H13.5552V8.46509H15.6942C17.7242 8.46509 18.5872 9.20409 18.5872 10.6811C18.5872 12.2041 17.5762 12.9711 15.6942 12.9711H14.7042ZM14.7042 9.54108V11.8971H15.7782C16.8432 11.8971 17.3942 11.5411 17.3942 10.6531C17.3942 9.85008 16.9162 9.54108 15.7952 9.54108H14.7042Z",
    fill: "#080808"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1929 10.6611C19.4959 10.4271 20.047 10.2411 20.838 10.2411C22.179 10.2411 22.84 10.7081 22.84 11.9241V15.0091H21.83V14.1671C21.61 14.7101 21.0489 15.0831 20.3139 15.0831C19.3869 15.0831 18.835 14.5511 18.835 13.6351C18.835 12.5691 19.597 12.269 20.727 12.269H21.765V12.063C21.765 11.399 21.453 11.1941 20.838 11.1941C19.992 11.1941 19.5059 11.5301 19.1929 12.0261V10.6611ZM21.765 13.3641V12.98H20.856C20.222 12.98 19.919 13.1021 19.919 13.5231C19.919 13.8791 20.176 14.1031 20.654 14.1031C21.38 14.1011 21.719 13.6811 21.765 13.3641Z",
    fill: "#080808"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.373 10.3351H24.576L25.834 13.5411L26.862 10.3351H28L26.163 15.5051C25.759 16.6271 25.3451 16.8791 24.7401 16.8791C24.4551 16.8791 24.1431 16.7951 24.0051 16.6721V15.6541C24.1431 15.7941 24.355 15.8881 24.556 15.8881C24.886 15.8881 25.1341 15.6641 25.3091 15.0281L23.373 10.3351Z",
    fill: "#080808"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.04297 10.6671V12.1021L4.91397 13.295L9.38898 9.93805C9.23098 9.58205 9.03297 9.25009 8.79997 8.94409L4.91397 11.8591L3.04297 10.6671Z",
    fill: "#080808"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.689 11.896C8.69 11.93 8.69 11.965 8.69 11.999C8.69 14.119 6.995 15.843 4.914 15.843C2.832 15.843 1.136 14.119 1.136 11.999C1.136 9.87802 2.831 8.15503 4.912 8.15503C5.702 8.15503 6.435 8.40199 7.041 8.82599L7.996 8.10901C7.154 7.41601 6.08 7 4.911 7C2.198 7 0 9.239 0 12C0 14.761 2.2 17 4.911 17C7.624 17 9.82201 14.761 9.82201 12C9.82201 11.694 9.794 11.394 9.743 11.104L8.689 11.896Z",
    fill: "#080808"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSberpay);
export default __webpack_public_path__ + "static/media/sberpay.6a1a1df6a24ce5dd56f019c3670c8120.svg";
export { ForwardRef as ReactComponent };